import AmbiImage from './1000plus1_logo.png'
import './AmbiLogo.css'

const AmbiLogo = () => <img className="logo" src={AmbiImage} />

export default AmbiLogo
